import classnames from 'classnames';
import { noop } from 'ramda-adjunct';
import React, { FC } from 'react';
import { GalleryFileThumbnail } from '../../../../../../../components/layouts/Gallery/GalleryFile/GalleryFileThumbnail';
import { ItemName } from '../../../../../../../components/layouts/Gallery/ItemName';
import { GenericItem } from '../../../../../../../components/layouts/Generic/GenericItem';
import styles from './ReadonlyFile.scss';
import { IInner, IOuter } from './ReadonlyFile.types';

export const ReadonlyFile: FC<IOuter & IInner> = ({
  item,
  className,
  isSelected = false,
  onClick = noop,
  onDoubleClick = noop,
  isDisabled = false,
  dataHookId,
}) => (
  <GenericItem item={item} dataHookId={dataHookId} onDoubleClick={onDoubleClick} onClick={onClick} noContextMenu>
    <div className={classnames(styles.file, className)} data-hook="file-gallery-file" data-hook-selected={isSelected}>
      <div
        className={classnames(
          styles.thumbnailWrapper,
          styles.selectable,
          isSelected && styles.selected,
          isDisabled && styles.disabled,
        )}
      >
        <GalleryFileThumbnail
          className={styles.thumbnail}
          file={item}
          width={80}
          height={80}
          thumbnailSize="small"
          labelClassName={styles.fileTypeLabel}
        />
      </div>

      <div className={styles.name} data-hook="file-gallery-file-name">
        <ItemName>{item.name}</ItemName>
      </div>
    </div>
  </GenericItem>
);
